import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Custom from './custom'

/**
 * This store will be used for all modules of this component
 */
const state = {
  commonObj: {
    hasDropdownLoaded: false,
    genderList: Custom.genderList,
    serviceTypeList: [],
    eventTypeList: [],
    eventList: [],
    serviceProcessStepList: [],
    fairStallList: [],
    patientCategoryList: [],
    stallTypeList: [],
    markingTypeList: Custom.markingTypeList,
    disabilityTypeList: [],
    patientList: [],
    maritalStatusList: Custom.maritalStatusList,
    wardTypeList: Custom.wardTypeList,
    stallList: [],
    employerList: [],
    yearList: Custom.yearList,
    assistiveDeviceList: [],
    assitiveDeviceApplicationTypeList: Custom.assitiveDeviceApplicationTypeList,
    assitiveDeviceApplicationList: Custom.assitiveDeviceApplicationList,
    donationTypeList: Custom.donationTypeList,
    municipalityList: Custom.municipalityList,
    areaTypeList: Custom.areaTypeList,
    idscCenterList: [],
    supplierInfoList: [],
    circularList: [],
    groupList: [],
    instituteList: [],
    skillList: [],
    educationLevelList: [],
    degreeList: [],
    educationalBoardList: Custom.educationalBoardList,
    educationalResultTypeList: Custom.educationalResultTypeList
  },
  static: {
    loading: false
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
